export const majorRoutes: string[] = [
  '/dashboard',
  '/framework/frameworks',
  '/project/projects',
  '/user/users',
  '/client/clients',
  '/lookup/client-category',
  '/proposal/proposals',
  '/ifs-tracker', 
  '/invoicing',
];